import { render, staticRenderFns } from "./promptComboList.vue?vue&type=template&id=1f407a5a&scoped=true"
import script from "./promptComboList.vue?vue&type=script&lang=js"
export * from "./promptComboList.vue?vue&type=script&lang=js"
import style0 from "./promptComboList.vue?vue&type=style&index=0&id=1f407a5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f407a5a",
  null
  
)

export default component.exports